import { render, staticRenderFns } from "./FinancePartnersPage.vue?vue&type=template&id=8653bbaa&"
import script from "./FinancePartnersPage.vue?vue&type=script&lang=js&"
export * from "./FinancePartnersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports